import { useMemo } from 'react'
import styled from 'styled-components'
import { AppModal } from '../../../../../generic/ui/Modal'
import { GridTable, TableSummary, TableToolbar } from '../../../../../generic/grid-table'
import ReportFilterForm from '../Q4/Components/ReportFilterForm'
import { useQ2Report } from './hooks/useQ2Report'
import { buildQ2Columns } from './configs/q2.columns'
import { buildQ2SummaryItems } from './configs/q2.summary'
import { Q2Row } from './types/row'

const MainQ2 = () => {
  const {
    metaData,
    rows,
    totalCount,
    hasData,
    isLoading,
    summary,
    searchQuery,
    handleSearch,
    isFilterOpen,
    toggleFilter,
    filterFormProps,
    handleExport,
  } = useQ2Report()

  const columns = useMemo(() => (metaData ? buildQ2Columns(metaData) : []), [metaData])
  const summaryItems = useMemo(() => buildQ2SummaryItems(summary), [summary])

  return (
    <TableSection>
      {isFilterOpen && (
        <AppModal
          title='שאילתת תעודות כניסה'
          Children={ReportFilterForm}
          childrenProps={filterFormProps}
          controlFunc={toggleFilter}
          size='sm'
        />
      )}
      <GridTable<Q2Row>
        title='סיכום תעודות כניסה Q2'
        count={totalCount}
        columns={columns}
        rows={rows}
        getRowId={(row) => row.rowId}
        isLoading={isLoading}
        emptyTitle='בחר דוח ותאריכים'
        summary={hasData ? <TableSummary items={summaryItems} /> : undefined}
        collapsibleSummary
        toolbarActions={
          <TableToolbar
            searchValue={searchQuery}
            onSearchChange={handleSearch}
            searchPlaceholder='חיפוש…'
            onExport={handleExport}
            onFilter={toggleFilter}
          />
        }
      />
    </TableSection>
  )
}

export default MainQ2

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
  overflow: hidden;
`
